import React, { Component } from 'react';
import SignUpPresenter from '@/components/contents/user/SignUp/SignUpPresent';
import { toRegexCheck } from '@/utils/validation.util';
import { getClientMessage } from '@/utils/massage.util';
import request from '@/services/request.service';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { modalActions } from '@/stores/action/widget.action';
import { toFormData } from '@/utils/convert.util';
import { DO_MAIN } from '@/constants/myconstants';
import { getLocaleWordContent } from '@/utils/language.util';

class SignUpContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {
                c_name: '',
                country: '',
                phone: '',
                userid: '',
                pass: '',
                pass_cfm: '',
                pin: '',
                pin_cfm: '',
                referral: '',
                referral_name: '',
                s_id: '',
                spon_name: '',
                center: '',

                // mail: '',
                domain: DO_MAIN,
            },
            validation: { terms: false, message: { userid: '', pass: '', phone: '' } },
            message_success: '',
            path: '',
        };
    }
    componentDidMount() {
        const { user, validation } = this.state;
        this.setState({ user: { ...user } });

        const param = window.location.hash.split('?')[1] ? window.location.hash.split('?')[1] : null;
        if (param) {
            if (!param.startsWith('check=')) {
            this.setState({ user: { ...user, referral: param } });
            setTimeout(() => {
                this.handleReferal();
            }, 1000);
            } else {
                if (param == 'check=true') {
                    this.setState({ validation: { ...validation, terms: true } });
                } 
            }
        }
    }

    handleChangeInput = (e) => {
        const { value, checked, name, type } = e.target;

        const actualVal = ['checkbox', 'radio'].includes(type) ? checked : value;
        const splitName = name.split('.');
        this.setState(
            {
                [splitName[0]]: {
                    ...this.state[splitName[0]],
                    [[splitName[1]]]: name === 'user.c_name' ? actualVal.replace(/[0-9]/g, '') : actualVal,
                },
            } /* , ()=> console.log(this.state[splitName[0]]) */,
        );
    };
    handleValidateMsg = (key) => {
        const { validation, user } = this.state;
        const setMessageHelper = (msg) =>
            this.setState(
                {
                    validation: { ...validation, message: { ...validation.message, [key]: msg || '' } },
                } /* , () => console.log(validation.message[key]) */,
            );
        if (!user[key]) return setMessageHelper();
        if (['phone'].includes(key)) {
            if (toRegexCheck(key, user[key]))
                return getClientMessage(`error.${key}.pattern`).then((msg) => setMessageHelper(msg));
            else return setMessageHelper();
        }
    };

    handleValidateCheck() {
        // validation
        const { user, validation } = this.state;

        return new Promise((resolve) => {
            if (validation.terms === false)
                return getClientMessage('error.signup.disagree').then((msg) => window.alert(msg));

            if (user.pass !== user.pass_cfm)
                return getClientMessage('error.signup.pass_cfm').then((msg) => window.alert(msg));

            if (user.pin !== user.pin_cfm)
                return getClientMessage('error.signup.pin_cfm').then((msg) => window.alert(msg));
            // if (toRegexCheck('email', user.userid))
            //     return getClientMessage('error.email.pattern').then((msg) => window.alert(msg));
            // if (toRegexCheck('email', user.mail))
            //     return getClientMessage('error.email.pattern').then((msg) => window.alert(msg));
            else if (toRegexCheck('password', user.pass))
                return getClientMessage('error.password.pattern').then((msg) => window.alert(msg));
            else if (toRegexCheck('pin', user.pin))
                return getClientMessage('error.pin.pattern').then((msg) => window.alert(msg));
            else if (toRegexCheck('phone', user.phone))
                return getClientMessage('error.tel.pattern').then((msg) => window.alert(msg));
            // else if(user.country === '')
            //     return getClientMessage("error.country.empty").then(msg => window.alert(msg))
            else return resolve();
        });
    }
    async handleSignUpRequest() {
        console.log('handleSignUpRequest+++');
        try {
            const response = await request.post('/api/account/signup.php', toFormData(this.state.user));
            // getServerMessage(response.data.msg).then(msg => window.alert(msg))
            // open pop-up sign success

            if (Number(response.data.result) === 1) {
                this.setState({
                    message_success: `OK. Confirmation complete \n ${response.data.msg}`,
                    path: '/',
                });
                this.props.ModalActions.showMessage({ show: true });
            } else {
                this.setState({
                    message_success: `Sign Up false. Please check your information !\n${response.data.msg}`,
                    path: null,
                });
                this.props.ModalActions.showMessage({ show: true });
            }
        } catch (e) {
            getClientMessage('error.network.connect').then((msg) => window.alert(msg));
        }
    }

    handleSubmit = (e) => {
        if (e) e.preventDefault();
        // const { user } = this.state;
        // if (user.mail === '') {
        //     this.setState({ user: { ...user, mail: user.userid } });
        // }
        this.handleValidateCheck().then(() => {
            this.handleSignUpRequest();
        });
    };
    // check user id
    async handleCheck() {
        const { user } = this.state;
        const param = { userid: user.userid, type: 'b' };
        try {
            const response = await request.post('/api/account/check_id.php', toFormData(param));
            if (Number(response.data.result) === 5) {
                this.setState({ user: { ...user, userid: user.userid } });
            } else {
                this.setState({
                    message_success: getLocaleWordContent('중복된 ID 입니다'),
                    path: null,
                });
                this.props.ModalActions.showMessage({ show: true });
            }
        } catch (e) {
            getClientMessage('error.network.connect').then((msg) => window.alert(msg));
        }
    }

    handleBlurId = (e) => {
        if (e) e.preventDefault();
        this.handleCheck();
    };
    // refer
    async handleReferal() {
        const { user } = this.state;
        const param = { userid: user.referral, type: 'c' };
        try {
            const response = await request.post('/api/account/check_id.php', toFormData(param));
            if (Number(response.data.result) === 1) {
                this.setState({ user: { ...user, referral_name: response.data.name } });
            } else if (Number(response.data.result) === 5) {
                this.setState({
                    message_success: response.data.msg,
                    path: null,
                });
                this.props.ModalActions.showMessage({ show: true });
            } else {
                this.setState({
                    message_success: 'userid is wrong',
                    path: null,
                });
                this.props.ModalActions.showMessage({ show: true });
            }
        } catch (e) {
            getClientMessage('error.network.connect').then((msg) => window.alert(msg));
        }
    }

    handleBlur = (e) => {
        if (e) e.preventDefault();
        this.handleReferal();
    };
    // spon
    async handleSponsor() {
        const { user } = this.state;
        const param = { userid: user.s_id, type: 'h' };
        try {
            const response = await request.post('/api/account/check_id.php', toFormData(param));
            if (Number(response.data.result) === 1) {
                this.setState({ user: { ...user, spon_name: response.data.name } });
            } else {
                this.setState({
                    message_success: response.data.msg,
                    path: null,
                });
                this.props.ModalActions.showMessage({ show: true });
            }
        } catch (e) {
            getClientMessage('error.network.connect').then((msg) => window.alert(msg));
        }
    }
    handleBlur2 = (e) => {
        if (e) e.preventDefault();
        this.handleSponsor();
    };
    // center

    render() {
        const { user, validation, message_success, path } = this.state,
            { handleChangeInput, handleSubmit, handleValidateMsg, handleBlurId, handleBlur, handleBlur2 } = this;
        return (
            <SignUpPresenter
                user={user}
                validation={validation}
                onChangeInput={handleChangeInput}
                onSubmit={handleSubmit}
                onValidateMsg={handleValidateMsg}
                message_success={message_success}
                path={path}
                onHandleBlur={handleBlur}
                onHandleBlur2={handleBlur2}
                onHandleBlurId={handleBlurId}
            />
        );
    }
}

export default connect(null, (dispatch) => ({
    ModalActions: bindActionCreators(modalActions, dispatch),
}))(withRouter(SignUpContainer));
